module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“I")])]), _vm._v(" wish you would reconsider.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jace Barnett didn’t look up from the desk he was cleaning out. He didn’t need to see to know it was Tim Potter who stood on the other side. The captain had tried to stop him when he left the disciplinary hearing, but Jace had gotten away without speaking to him. He’d known his luck wouldn’t hold until he left the building, but after the hearing, he just hadn’t given a damn.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You caught a bad break, Jace—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shoved the drawer shut and began gathering the few items on the desktop. “A bad break? I didn’t do anything wrong, but the department hung me out to dry anyway because it was politically expedient.” He loaded the last two words with every bit of the disgust he felt for them, for the higher-ups who’d sat in judgment of him, for the machine that had sacrificed him for the chief’s greater good.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("“I know,” Potter said, his tone as conciliatory as Jace’s wasn’t. “You got a raw deal, and I swear, we’ll make it up ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("to you. But that’s going to be hard if you go crawling off with your feelings hurt.”")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The only personal item remaining on the desk was a photograph taken two months earlier. The Barnett clan at Thanksgiving—his parents, Ray and Rozena; his uncle Del and aunt Lena; his cousin Reese and his wife, Neely. Jace stood in the middle with Amanda, his arm around her shoulders. She was gone now, part of the fallout of his “raw deal.” She’d liked cops in general and him in particular, but not after the suspension. Not once he’d become the target of a very public and negative witch-hunt. Last he’d heard, she was seeing some detective in Vice, and she was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in love.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hoped the vice cop had a more realistic understanding of what that meant than he’d had. He’d believed her—had even been planning to ask her to marry him once this mess was over. He’d been a first-class sucker.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He put the photo in his gym bag, then stood and met Potter’s gaze. “I’m not crawling off. I’m getting the hell out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But, Jace— A couple more years and you can retire. You don’t want to give that up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jace switched the gym bag to his other hand, scooped his coat off the desk and headed for the door. “Screw retirement. Screw the job. Screw you all.” Just like they’d screwed him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was almost outside when Potter caught his arm. “Forget the resignation, Jace. We’ll consider this a temporary leave of absence. Take some time to cool off and think about it clearly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d had nothing to do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but")]), _vm._v(" think since they’d pulled him off the job weeks ago. He’d thought until he was sick of it, and he’d always reached the same conclusion. It was time to get out. If this treatment was the best the Kansas City Police Department could do for one of its wronged veteran detectives, he no longer wanted to be a part of it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("It had begun snowing while he was inside. He stopped, pulled on his coat and gloves, then opened the door. Frigid air along with a few flakes rushed inside as he looked back at Potter. “I’ve given this department my best for more than ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("fifteen years—my dedication, my loyalty, my support—and the first time I need some of it back, you tell me to bend over and take it quietly, then get back to the job as if nothing happened. Well, Captain, it ain’t gonna happen. I’m outta here.”")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stepped out into the snow and headed for his truck. Potter stepped out after him, but didn’t speak. When Jace pulled away from the curb, the captain was still standing there, snow coating his gray hair and shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His fingers tight around the steering wheel, Jace headed for his apartment. He’d been a damned fool. All along he’d believed today’s hearing would exonerate him. The suspension, the investigation, being yanked off his cases—that was all routine whenever allegations of wrongdoing were made against an officer. He’d hated it, but he’d been positive everything would turn out in his favor. Hell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he’d done nothing wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Except believe in the department and the people he’d worked with.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Except think that seventeen years of outstanding service counted for something.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Except assume that the truth actually counted for something.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Today he’d learned better. The police chief had a run for the governor’s office in mind, and justice for one detective stood little chance against his ambitions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seventeen years patrolling the streets, working Homicide and Sex Crimes and Narcotics, seventeen years of dealing with scum, working long hours for too little pay, facing danger more often than he wanted to recall, and this was the thanks he got. Sacrificed for the benefit of the chief’s public image.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was only a few blocks from the apartment when he saw a car at the side of the road. Its right wheels were in a ditch, its headlights pointed up and illuminating the snow that darkened the afternoon. A woman stood near the rear of the car, huddled in her coat and looking helplessly at the vehicle. Automatically he eased his foot off the gas and switched on his blinker to pull onto the shoulder.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Deliberately he shut off the blinker and pressed the gas pedal down instead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was out of the help-giving business.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Forever.")])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d4dc2b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426873966_fm03.vue
// module id = 72
// module chunks = 0